import { GenIcon } from '../helpers/IconBase.es.js';

const UserProfileColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_15571_332)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M10 9.99994C10.9889 9.99994 11.9556 9.7067 12.7779 9.15729C13.6001 8.60788 14.241 7.82699 14.6194 6.91336C14.9978 5.99973 15.0969 4.99439 14.9039 4.02449C14.711 3.05458 14.2348 2.16367 13.5355 1.46441C12.8363 0.765145 11.9454 0.288941 10.9755 0.0960148C10.0055 -0.0969113 9.00021 0.00210539 8.08658 0.380544C7.17295 0.758982 6.39206 1.39984 5.84265 2.22209C5.29324 3.04434 5 4.01103 5 4.99994C5.00132 6.32562 5.52853 7.59662 6.46593 8.53401C7.40332 9.47141 8.67432 9.99862 10 9.99994ZM10 1.66661C10.6593 1.66661 11.3037 1.8621 11.8519 2.22838C12.4001 2.59465 12.8273 3.11524 13.0796 3.72433C13.3319 4.33342 13.3979 5.00364 13.2693 5.65024C13.1407 6.29685 12.8232 6.89079 12.357 7.35696C11.8908 7.82314 11.2969 8.14061 10.6503 8.26923C10.0037 8.39784 9.33348 8.33183 8.72439 8.07954C8.1153 7.82725 7.59471 7.40001 7.22844 6.85184C6.86216 6.30368 6.66667 5.65921 6.66667 4.99994C6.66667 4.11589 7.01786 3.26804 7.64298 2.64292C8.2681 2.0178 9.11595 1.66661 10 1.66661Z",
              fill: "#00973C"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10 11.6672C8.01155 11.6694 6.10518 12.4603 4.69914 13.8663C3.29309 15.2724 2.50221 17.1787 2.5 19.1672C2.5 19.3882 2.5878 19.6002 2.74408 19.7564C2.90036 19.9127 3.11232 20.0005 3.33333 20.0005C3.55435 20.0005 3.76631 19.9127 3.92259 19.7564C4.07887 19.6002 4.16667 19.3882 4.16667 19.1672C4.16667 17.6201 4.78125 16.1363 5.87521 15.0424C6.96917 13.9484 8.4529 13.3338 10 13.3338C11.5471 13.3338 13.0308 13.9484 14.1248 15.0424C15.2188 16.1363 15.8333 17.6201 15.8333 19.1672C15.8333 19.3882 15.9211 19.6002 16.0774 19.7564C16.2337 19.9127 16.4457 20.0005 16.6667 20.0005C16.8877 20.0005 17.0996 19.9127 17.2559 19.7564C17.4122 19.6002 17.5 19.3882 17.5 19.1672C17.4978 17.1787 16.7069 15.2724 15.3009 13.8663C13.8948 12.4603 11.9884 11.6694 10 11.6672Z",
              fill: "black",
              fillOpacity: "0.88"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_15571_332" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { UserProfileColored };
